<template>
  <VLayout column>
    <Header/>
    <InfoPayDone/>
    <Footer/>
  </VLayout>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import InfoPayDone from '@/components/InfoPayDone.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'PayDone',
  components: {
    Header,
    InfoPayDone,
    Footer,
  },
  data: () => ({
    showRemotePaymentImage: true,
    headerForImage: 120,

  }),
};
</script>

<style scoped>

</style>
